import React from 'react';
import { Helmet } from 'react-helmet';

const CatHouseWebsite = () => {
    return (
        <>
            <Helmet>
                <title>CatHouse Tattoo Case Study | We Are A Site</title>
                <meta name="description" content="Explore our upcoming work for CatHouse Tattoo—a bold and edgy custom website tailored for artists." />
            </Helmet>
            <div className='CatHouseWebsite PortfolioWebsite'>
                <div className='WebsiteHeader'>
                    <img src='/images/CatHouseIcon.png' alt='Preview' />
                    <div className='WebsiteHeaderInfo'>
                        <span className='BusinessAttribute BusinessName'><span className='BusinessLabel'>Business Name: </span>Cat House Tattoo</span>
                        <span className='BusinessAttribute BusinessType'><span className='BusinessLabel'>Business Type: </span>Tattoo Studio</span>
                        <span className='BusinessAttribute BusinessLaunchYear'><span className='BusinessLabel'>Launch Year: </span>2025</span>
                        <span className='BusinessAttribute BusinessLink'><span className='BusinessLabel'>Link: </span><a href='https://cathousetattoo.com' target='blank'>https://cathousetattoo.com</a></span>
                    </div>
                </div>
                <div className="WebsiteSection WebsiteDescription">
                    <h1>Description:</h1>
                    <span></span>
                </div>
                <div className="WebsiteSection WebsiteSpecialFeatures">
                    <h1>Special Features:</h1>
                    <span></span>
                </div>
                <div className="WebsiteSection WebsiteTotalPages">
                    <h1>Total Pages:</h1>
                    <span></span>
                </div>
                <div className="WebsiteSection WebsiteDemo">
                    <h1>Demo:</h1>
                    <span></span>
                </div>
            </div>
        </>
    );
};

export default CatHouseWebsite;
